import { TPMPermissionsDB, TUserPermissionsUI } from './permissions.types';

export enum EUserRolesDB {
  ADMIN = 'admin',
  LANDLORD = 'landlord',
  PROPERTY_MANAGER = 'propertyManager',
}

export enum EUserRolesUI {
  ADMIN = 'admin',
  LANDLORD = 'landlord',
  PROPERTY_MANAGER = 'propertyManager',
}

// Mirrors backend PropertyManagementPlan; API and UI use the same values
export enum EPropertyManagementPlan {
  PRO_PLAN = 'PRO_PLAN',
  STANDARD_PLAN = 'STANDARD_PLAN',
  ASSISTANCE_ANIMAL_ONLY = 'ASSISTANCE_ANIMAL_ONLY',
}

export type TImpersonatedOnUI = {
  userId: string;
  name: string;
};

export type TImpersonatedOnDB = {
  userId: string;
  name: string;
};
export type TUserAdminDB = {
  userId: string;
  name: string;
  username: string;
  email: string;
  phone: string | number;
  impersonateOn: TImpersonatedOnDB | null;
};

export type TUserAdminUI = {
  id: string;
  name: string;
  username: string;
  email: string;
  phone: string | number;
  impersonateOn: TImpersonatedOnUI | null;
};

export type TUserPropertyManagerUI = {
  id: string;
  landlordId: string;
  name: string;
  username: string;
  email: string;
  phone: string | null;
  profilePicture: string | null;
  position: string | null;
  propertyManagementId: string | null;
  propertyManagementName: string | null;
  propertyManagementLogo: string | null;
  canCreateContract: boolean;
  hasAccessToReports: boolean;
  type: EUserRolesUI;
  hasAccessToCourses: boolean;
  plan: EPropertyManagementPlan | null;
  hasAccessToBillingMethod: boolean;
  readOnlyAccess?: boolean;
  permissions?: TUserPermissionsUI;
};

export type TUserPropertyManagerDB = {
  id: string;
  landlordId: string;
  name: string;
  username: string;
  email: string;
  phone: string | null;
  profilePicture: string | null;
  position: string | null;
  propertyManagementId: string | null;
  propertyManagementName: string | null;
  propertyManagementLogo: string | null;
  canCreateContract: boolean;
  hasAccessToReports: boolean;
  type: EUserRolesDB;
  hasAccessToCourses: boolean;
  plan: EPropertyManagementPlan | null;
  hasAccessToBillingMethod: boolean;
  readOnlyAccess?: boolean;
  permissions?: TPMPermissionsDB;
};
export type TUserDataTypeUI = TUserAdminUI | TUserPropertyManagerUI;
export type TUsersDataByTypeUI = {
  [key in EUserRolesUI]?: TUserDataTypeUI | null;
};

export type TUserTypeDataUI = {
  id: string;
  name: string;
  photo: string;
  type: EUserRolesUI;
};

export type TUserTypeDataDB = {
  id: string;
  name: string;
  photo: string;
  type: EUserRolesDB;
};
// export type TUserDataByTypeUI = TUserAdminUI | TUserPropertyManagerUI;
export type TGetUserDataUI = {
  userType: EUserRolesUI | null;
  impersonateOn: boolean | null;
  users: {
    [EUserRolesUI.ADMIN]: TUserAdminUI | null;
    [EUserRolesUI.PROPERTY_MANAGER]: TUserPropertyManagerUI | null;
    [EUserRolesUI.LANDLORD]: TUserPropertyManagerUI | null;
  } | null;
};
